import { createInertiaApp, Link } from '@inertiajs/vue3'
import { Inkline } from '@inkline/inkline'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { useCookies } from '@vueuse/integrations/useCookies'
import { createApp, h } from 'vue'
import useErrorMiddleware from '@/js/useErrorMiddleware.js'
import usePosthog from '@/js/usePosthog.js'
import '@/styles/index.css'

createInertiaApp({
  progress: {
    color: 'var(--system-picsellia)',
  },
  resolve: (name) => {
    const pages = import.meta.glob('./pages/**/*.vue')
    return pages[`./pages/${name}.vue`]()
  },
  async setup({ el, App, props, plugin }) {
    const app = createApp({
      render: () => h(App, props),
    })
    app.use(plugin)
    app.use(VueQueryPlugin, {
      queryClientConfig: {
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60 * 5, // 5 min
          },
        },
      },
    })
    app.use(Inkline, {
      colorMode: 'light',
      routerComponent: Link,
    })
    const cookies = useCookies(['picsellia-tools'])
    const picselliaTools = cookies?.get('picsellia-tools') ?? ''

    await useErrorMiddleware(picselliaTools.includes('sentry'), app)
    app.mount(el)
    await usePosthog(picselliaTools.includes('posthog'))
  },
})
